/* ------------------------------------------------------------------------
Copyright (c) 2016, VoiceVibes, Inc

VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
All contents of this file are proprietary and confidential. No part of
any of the contents of this file may be disclosed in any manner to
a third party without the prior written consent of VoiceVibes, Inc.
Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

<template>
  <div
    id="assignmentSharing"
    class="form-group"
  >
    <label
      v-if="sharingEnabled"
      :for="'shareRecording' + refNum"
      class="control-label lower"
    >
      <input
        :id="'shareRecording' + refNum"
        v-model="formData.feedbackRequested"
        type="checkbox"
        value="1"
        @input="sharingChanged"
      >
      Share recording with entire group
    </label>
    <br
      v-if="sharingEnabled"
    >
    <label
      :for="'submitRecording' + refNum"
      class="control-label lower"
    >
      <input
        :id="'submitRecording' + refNum"
        v-model="formData.submitted"
        type="checkbox"
        value="1"
        @input="sharingChanged"
      >
      Flag recording for coach review
    </label>
  </div>
</template>


<style lang="less" scoped>
  label {
    font-size: 11px;
  }
  input {
    position: relative;
    top: 2px;
  }
</style>

<script>
export default {
  props: ['refNum'],
  data() {
    return {
      formData: {
        feedbackRequested: false,
        submitted: false,
      }
    };
  },
  computed: {
    activeGroups: {
      cache: false,
      get() {
        return this.$store.getters.activeGroups;
      }
    },
    sharingEnabled: {
      cache: false,
      get() {
        let sharingEnabled = false;
        this._.forEach(this.activeGroups, (group) => {
          if (group.speakerPrivacyLevel !== 4) {
            sharingEnabled = true;
          }
        });
        return sharingEnabled;
      }
    },
  },
  methods: {
    sharingChanged() {
      // formData needs a min to update
      window.setTimeout(() => this.$emit('sharingChanged', this.formData), 50);
    },
  }
};
</script>
